<template>
  <div>
    <v-card>
      <v-container>
        <v-row no-gutters class="d-flex align-center">
          <v-col cols="12" md="9">
            <v-btn class="info" small @click="openAddDialog">
              <v-icon small left>mdi-plus</v-icon>
              {{ $t("createPermissionsGroup") }}
            </v-btn>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-on="on" v-bind="attrs" class="ml-2" color="primary">
                  mdi-information-outline
                </v-icon>
              </template>
              <span>{{ $t("groupsTooltip") }}</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              hide-details
              dense
              solo-inverted
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        :items-per-page="-1"
      >
        <template v-slot:item.id="{ item }">
          <v-btn @click="$copy(item.id)" x-small>{{ item.id }}</v-btn>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn small @click="openEditDialog(item)">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "administrator-users-collaborators-list-permissions",
  data: () => ({
    dialog: false,
    search: "",
    items: [],
  }),
  mounted() {
    this.listGroups();
  },
  computed: {
    headers() {
      return [
        {
          text: "ID",
          value: "id",
        },
        {
          text: this.$t("group"),
          value: "descricao",
        },
        // {
        //   text: this.$t("managed"),
        //   value: "gerenciado",
        // },
        // {
        //   text: this.$t("status"),
        //   value: "status",
        // },
        {
          text: this.$t("actions"),
          value: "actions",
          // align: "center",
          sortable: false,
        },
      ];
    },
    refresh() {
      return this.$store.state.refresh;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    // Recupera o state da dialog para ser observado no watch.
    getDialogState() {
      return this.$store.state.showDialog;
    },
  },
  watch: {
    saveFilters(val) {
      val && this.listGroups();
    },
    refresh(val) {
      val && this.listGroups();
      this.$store.commit("setRefresh", false);
    },
  },
  methods: {
    listGroups() {
      this.$axios
        .post("administrator/colab/listGroups")
        .then((response) => {
          if (response.status === 200) {
            this.items = response.data.dados;
            this.items.reverse();
          }
        })
        .catch((response) => {
          if (!response.length) {
            this.items = [];
          }
        });
    },
    openAddDialog() {
      this.$router.push({ name: "AdministratorCreatePermissionsGroup" });
      this.$store.commit("showDialog", true);
    },
    openEditDialog({ id, descricao }) {
      this.$router.push({
        name: "AdministratorEditPermissionsGroup",
        query: { id_group: id, descricao },
      });
      this.$store.commit("showDialog", true);
    },
  },
};
</script>
